import { Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { Dictionary } from '../filtering-search-component-base/filtering-search-types'
import { IconNamesEnum, NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'
import { expandCollapse, openClose } from '../../animations/open-close-animations'
import { Router } from '@angular/router'
import { StripTagsPipe } from '../../pipes/striptags.pipe'
import { CourtDocumentsComponent } from '../court-documents/court-documents'

@Component({
    animations: [
        openClose,
        expandCollapse,
    ],
    selector: 'keip-view',
    templateUrl: './keip-view.component.html',
    styleUrls: ['./keip-view.component.scss'],
    imports: [
        NgxBootstrapIconsModule,
        CourtDocumentsComponent,
        StripTagsPipe,
    ]
})
export class KEIPViewComponent {
  private router = inject(Router)

  @Input() keip : any = {}
  @Output() instrumentID = new EventEmitter<string>()

  public isExpanded: Dictionary<boolean> = {}
  public iconNames = IconNamesEnum

  public getArrayElementById(keip: any[], key: string, value: string) : any {
    return keip.find(element => element[key] === value)
  }


  public gotoInstrument(event: Event, instrument : any) {
    event.preventDefault()

    if (this.instrumentID.observed) {
      this.instrumentID.emit(instrument.instrument_id)
    } else {
      this.router.navigateByUrl('/data/instruments/' +  instrument.articleID)
    }
  }
}
